import { setBodyBusy } from 'helpers/uiHelpers';
import {
	filter,
	find,
	flatten,
	forEach,
	get,
	groupBy,
	includes,
	isEmpty,
	reject,
} from 'lodash';
import orderBy from 'lodash/orderBy';

import {
	AUTOREFILL_OPTION, SIX_MONTH_CADENCE_OPTION
} from '../../../apps/medicationCheckoutV2/src/App.helpers';

function cartReducer(state, action) {
	if (action.type === 'setBodyBusy') {
		setBodyBusy(action.loading);
		return {
			...state,
			bodyBusy: action.loading,
		}
	}
	if (action.type === 'setupCart') {
		let _productOptions = [],
			_cadenceOptions = [],
			purchaseableProduct,
			businessLine;
		const { props } = action,
			{
				product_options, type, patient, isFollowup,
			} = props;
		let latisseSubPlan;
		if (patient) {
			latisseSubPlan = patient.latisseSubPlan;
		}
		if (product_options) {
			_productOptions = product_options
		}
		forEach(_productOptions,
			(p) => {
				p.autoRefill = false;
				if (p.options) {
					// set autoRefill to true if any options have autorefill
					forEach(p.options,
						(option) => {
							if ('autorefill' in option) {
								p.autoRefill = true;
								return;
							}
						})
				}
				// Update specific medication form terminology from singular to plural
				if (p.medication_form === 'tablet') {
					p.medication_form = 'tablets';
				} else if (p.medication_form === 'capsule') {
					p.medication_form = 'capsules';
				}
			});
		// We are sent all subscription product options and want to format them
		if (props.cart && props.cart.product_options) {
			_cadenceOptions = groupBy(props.cart.product_options,
				(option) => {
				// Sunset latisse starter 02.11.20, revert to default latisse
					if (option.plan_id === 'single_latisseStarter') {
						return 'LATISSE'
					}
					return option.product_type
				});
		}

		const typeToBusinessLine = {
			WRINKLE: 'FILI',
			LATISSE: 'LASH',
			MPB: 'HAIR',
		}

		if (isEmpty(type)) {
			businessLine = 'SKIN'
		} else if (isFollowup) {
			businessLine = 'VISIT'
		} else {
			businessLine = typeToBusinessLine[type]
		}

		let startEmpty = false;
		if (props.cart && props.cart.product && props.cart.product.product_type) {
			purchaseableProduct = props.cart.product.product_type;
		}

		const cartProps = {
			...action.props,
			productOptions: _productOptions,
			cadenceOptions: _cadenceOptions,
			purchaseableProduct,
			startEmpty,
		}
		const {
			cart, productOptions, cadenceOptions,
		} = setupCart(cartProps);
		return {
			...state,
			cart,
			productOptions,
			cadenceOptions,
			purchaseableProduct,
			businessLine,
		}
	}
	if (action.type == 'removeFromCart') {
		let cart = removeProductFromCart(state.cart,
			action.productId);
		cart = updateCartTotal(cart,
			state.patient);
		return {
			...state,
			cart,
		}
	}
	if (action.type === 'setAutoShip') {
		let cart = setAutoShip(state.cart,
			action);
		cart = updateCartTotal(cart,
			state.patient);
		return {
			...state,
			cart,
		}
	}
	if (action.type == 'setCadenceOption') {
		return {
			...state,
			cadenceOption: action.cadenceOption,
		}
	}
	if (action.type == 'addToCart') {
		let cart = addProductOptionToCart(state.cart,
			action.productId,
			action.option);
		cart = updateCartTotal(cart,
			state.patient);
		return {
			...state,
			cart,
		}
	}
	if (action.type == 'updateCartTotal') {
		const cart = updateCartTotal(state.cart,
			state.patient);
		return {
			...state,
			cart,
		}
	}
	if (action.type == 'updateDefaultPaymentMethod') {
		const defaultPaymentMethod = action.defaultPaymentMethod;
		return {
			...state,
			defaultPaymentMethod,
		}
	}
	if (action.type == 'applyPromoToCart') {
		const promoData = action.promoData;
		let response = applyPromoToCart(promoData,
			state);
		let cart = response.cart;
		let grouponProductOption, productType;
		if (promoData.source == 'GROUPON') {
			state.cart.grouponApplied = true;
			let code_type = promoData.code.substr(0,
				4);
			if (code_type == 'GRPF') {
				let cadence = promoData.discount_dollars >= 75 ? 3 : 1;
				grouponProductOption = find(state.cadenceOptions,
					(option) => option.frequency == cadence);
				productType = 'MPB'
			} else if (code_type == 'GRPT') {
				grouponProductOption = find(state.cadenceOptions,
					(option) => option.frequency == 3);
				productType = 'WRINKLE'
			}
		}
		if (grouponProductOption) {
			cart = addProductOptionToCart(cart,
				productType,
				grouponProductOption)
			cart = updateCartTotal(cart,
				state.patient)
		} else {
			cart = updateCartTotal(cart,
				state.patient)
		}
		return {
			...state,
			promo: response.promo,
			cart,
		}
	}
	if (action.type == 'removePromoFromCart') {
		const promoCode = action.promoCode;
		const cookies = action.cookies;
		const {
			cart, promo,
		} = removePromoFromCart(promoCode,
			state,
			cookies);
		return {
			...state,
			promo,
			cart,
		}
	}
	if (action.type == 'setPromoData') {
		const promo = action.promoData
		return {
			...state,
			promo,
		}
	}

	if (action.type === 'openCrossSell') {
		const {
			version, stepNext,
		} = action;
		return {
			...state,
			crossSell: {
				version,
				stepNext,
				modalOpen: true,
			},
		}
	}
	if (action.type === 'closeCrossSell') {
		return {
			...state,
			crossSell: {
				version: '',
				stepNext: '',
				modalOpen: false,
			},
		}
	}

	return state
}

function addProductOptionToCart(cart, productId, option) {
	cart = removeProductFromCart(cart,
		productId);
	productId = productId.toString();
	cart.products[productId] = option;
	return cart
}

function removeProductFromCart(cart, productId) {
	if (cart.products[productId]) { delete cart.products[productId] }
	return cart
}

function setAutoShip(cart, {
	productId, autoShip,
}) {
	if (cart.products[productId] && cart.products[productId].autorefill) {
		cart.products[productId].autorefill.selected = autoShip;
	}
	return cart;
}

function updateCartTotal(cart, patient) {
	cart.cartTotalCents = emptyCart.visitFeeCents; // reset to the determined visit fee
	// now add all of the products
	var gift_card_visit = false;

	var prePurchase = window && window.Yoderm && window.Yoderm.data && window.Yoderm.data.prePurchase;
	if (patient && patient.gift_cards && patient.gift_cards.length) {
		if (patient.registrationStep === 'PAYMENT')
			gift_card_visit = true
	}
	if (gift_card_visit || prePurchase) {
		cart.cartTotalCents = 0;
		cart.visitFeeCents = 0;
		cart.rx_credit = 0;
	}
	const products = Object.values(cart.products);
	products.forEach(option => {
		const autorefill = get(option,
			'autorefill',
			{});
		if (!isEmpty(autorefill) && autorefill.selected) {
			cart.cartTotalCents += autorefill.price_cents * (option.order_cadence || 1);
		} else {
			cart.cartTotalCents += option.price_cents;
		}
	});
	// Handle bundle discount, if both products are in cart
	if (cart.bundlePrice && cart.bundleDiscountPrice) {
		let topicalCount = 0;
		let oralCount = 0;
		cart.purchaseable_products.forEach(product => {
			if (product.medication_type === 'topical' && cart.products[product.id]) {
				topicalCount += 1;
			} else if (product.medication_type === 'oral' && cart.products[product.id]) {
				oralCount += 1;
			}
		});
		if (topicalCount === 1 && oralCount === 1) {
			cart.cartTotalCents -= (cart.bundlePrice - cart.bundleDiscountPrice);
			cart.RXKit = true
		} else {
			cart.RXKit = false
		}
	}
	if (prePurchase && !products.length) {
		const pre_purchase_products = cart.product_pre_purchase ? Object.values(cart.product_pre_purchase) : [];
		pre_purchase_products.forEach(option => {
			cart.cartTotalCents += option.price_cents;
		});
	}
	if ((products.length === 0 || prePurchase) && cart.promos.PRODUCT_CREDIT ) {
		delete cart.promos.PRODUCT_CREDIT
	}
	if (products.length > 0 && cart.initPromo && !prePurchase) {
		cart.promos.PRODUCT_CREDIT = cart.initPromo
	}
	// This sorts to make the "rx_credit" the LAST promo applied, but those promos with a min purchase value above anything else.
	let sortedPromos = orderBy(Object.values(cart.promos),
		(promo) => promo.min > 0);
	sortedPromos = orderBy(sortedPromos,
		(promo) => promo.code === 'rx_credit');
	Object.values(sortedPromos).forEach(promo => {
		if (promo.min && promo.min > (cart.cartTotalCents / 100)) {
			delete cart.promos[promo.code];
		} else if (cart.cartTotalCents >= promo.discount_cents) {
			cart.cartTotalCents -= promo.discount_cents;
			promo.applied_credit_cents = promo.discount_cents;
		} else {
			promo.applied_credit_cents = cart.cartTotalCents;
			cart.cartTotalCents = 0; // Never let the cart drop below 0.
		}
	});
	return cart;
}

function setupCart(props) {
	if (props.isFollowup) {
		emptyCart.visitFeeCents = props.followup_cost * 100;
		return { cart: emptyCart }
	} else if (props.otcCheckout) {
		emptyCart.visitFeeCents = 0;
		return { cart: emptyCart }
	}
	emptyCart.visitFeeCents = props.cart.consult.paid || props.cart.skip_consult ? 0 : props.cart.consultation.cost * 100;
	let cart = emptyCart;
	cart.purchaseable_products = props.productOptions || [];
	cart.followup_allowed = props.cart.followup_allowed || false;
	cart.conditionsTreated = props.cart.consultation.conditions;
	const productOptions = props.productOptions || [];
	const otcProducts = props.otc_product_options || [];
	let cadenceOptions = [];

	productOptions.forEach(product => {
		product.disabled = product.options.length === 0
		if (!product.disabled && !product.out_of_cart && !product.quantity_remaining <= 0) {
			product.options = orderBy(product.options,
				['quantity'],
				['desc']);

			// Make sure any order cadence values go first.
			product.options = orderBy(product.options,
				['order_cadence'],
				['asc']);

			const firstOptionId = product.options[0].id

			const defaultOption = find(product.options,
				['id', firstOptionId])
			// For ARCadence and 6MOCadence checkout, make sure we provide the AR Option.
			if ([AUTOREFILL_OPTION, SIX_MONTH_CADENCE_OPTION].includes(props.cadenceOption) && defaultOption.autorefill) {
				defaultOption.autorefill.selected = true
			}
			cart = addProductOptionToCart(cart,
				product.id,
				defaultOption)
		}
	});

	// Add OTCs to product list and put initial selected OTCs in cart
	if (otcProducts && otcProducts.length) {
		otcProducts.forEach((product) => {
			if (product.options && product.options.length) {
				productOptions.push(product);
				if (!product.options[0].out_of_cart) {
					cart = addProductOptionToCart(cart,
						product.id,
						product.options[0]);
				}
			}
		})
	}

	//Handle kit bundle pricing
	if (props.RXKit) {
		let bundlePrice = 0;
		// let bundleDiscountPrice = 0;
		productOptions && productOptions.forEach(product => {
			if (product.options.length > 0 && product.medication_type && product.descriptor && !product.descriptor.toLowerCase().includes('screen')) {
				bundlePrice += product.options[0].price_cents;
				// if (product.medication_type === "oral") {
				//   debugger // should be determined by rx_type
				//   if (product.rx_type === "SPIRONOLACTONE") {
				//     bundleDiscountPrice += 4800;
				//   } else {
				//     bundleDiscountPrice += 7500;
				//   }
				// } else {
				//   bundleDiscountPrice += 7500;
				// }
			}
		});
		cart.bundlePrice = bundlePrice;
		cart.bundleDiscountPrice = bundlePrice;
		if (props.RXKitDiscount) {
			// [default] $15 discount
			cart.bundleDiscountPrice -= props.RXKitDiscount;
			// cart.bundleDiscountPrice = bundlePrice - 1500; // previously: bundleDiscountPrice - 1000
		}
	}

	// Order cadence options in descending order (single purchase will always be last),
	// then grab the default option specified from the server.
	if (props.purchaseableProduct && !isEmpty(props.cadenceOptions)) {
		// Don't add any products to the cart if we are doing a SKIN visit.
		let defaultOption = props.cart.product

		// Set tretinoin into the cart if purchaseable product is WRINKLE.
		if (!defaultOption && props.purchaseableProduct == 'WRINKLE' ) {
			defaultOption = find(props.cadenceOptions.WRINKLE,
				option => option.frequency == 3)
		}

		if (defaultOption) {
			cadenceOptions = orderBy(
				props.cadenceOptions[props.purchaseableProduct],
				['frequency'],
				['desc']
			);
			cadenceOptions = reject(cadenceOptions,
				option => option.frequency == defaultOption.frequency)
			cadenceOptions = flatten([defaultOption, cadenceOptions])
			cadenceOptions.forEach(option => {
				option.price_cents = option.total_cost * 100
			})

			defaultOption = cadenceOptions[0]
			if (!props.startEmpty) {
				cart = addProductOptionToCart(cart,
					props.purchaseableProduct,
					defaultOption)
			}
			productCreditPromo.discount_cents = emptyCart.visitFeeCents;
			productCreditPromo.applied_credit_cents = emptyCart.visitFeeCents;
			cart.initPromo = productCreditPromo;
			cart.promos.PRODUCT_CREDIT = productCreditPromo
		}
	}

	if (props.cart.consult.product_credit_cents && props.cart.consult.product_credit_cents > 0) {
		productCreditPromo.discount_cents = props.cart.consult.product_credit_cents;
		productCreditPromo.applied_credit_cents = props.cart.consult.product_credit_cents;
		cart.initPromo = productCreditPromo;
		cart.promos.PRODUCT_CREDIT = productCreditPromo
	}

	return {
		cart,
		productOptions,
		cadenceOptions,
	}
}

function cartHasPromo(cart) {
	const except_credit = filter(cart.promos,
		(promo) => promo.code != 'rx_credit')
	if (!isEmpty(except_credit)) { return true }
}

function applyPromoToCart(promoData, state) {
	const response = {};
	if (cartHasPromo(state.cart)) {
		console.log('already has promo code');
		response.cart = state.cart;
		response.promo = {
			error: 'promo_applied',
			success: null,
			code: promoData.code,
			min: promoData.min_purchase || 0,
		}
	} else if (promoData.min_purchase && promoData.min_purchase > (state.cart.cartTotalCents / 100)) {
		console.log('Minimum amount for this promo has not been reached.');
		response.cart = state.cart;
		response.promo = {
			error: 'min_purchase',
			min: promoData.min_purchase || 0,
			success: null,
			code: promoData.code,
		}
	} else {
		state.cart.promos[promoData.code] = {
			description: `${promoData.code}`,
			code: promoData.code,
			min: promoData.min_purchase || 0,
			rx: promoData.rx_credit,
			discount_cents: promoData.discount_cents,
			deleteable: promoData.source === 'GROUPON',
			source: promoData.source,
		};

		if (promoData.rx_credit) {
			state.cart.rxCredit = promoData.rx_credit;
		}

		if (promoData.min_purchase) {
			state.cart.min_purchase = promoData.min_purchase;
		}

		response.cart = state.cart;

		response.promo = {
			error: null,
			success: 'added',
			code: promoData.code,
			source: promoData.source,
		}
	}
	return response
}

function removePromoFromCart(promoCode, state, cookies) {
	const response = {};
	// reset promo state to blank so a new one can be added.
	response.promo = {
		error: null,
		success: null,
		code: '',
	};
	if (cookies && cookies.get('promo_code')) {
		cookies.remove('promo_code',
			{ path: '/' });
	}
	// Since we only allow one promo code, delete all current promos
	state.cart.promos = [];
	response.cart = updateCartTotal(state.cart,
		state.patient);

	return response
}

let productCreditPromo = {
	description: 'Prescription credit',
	code: 'rx_credit',
	discount_cents: 0,
	applied_credit_cents: 0,
	deleteable: false,
};

let emptyCart = {
	cartTotalCents: 0,
	visitFeeCents: 0,
	products: {},
	promos: {},
};

export default cartReducer

export { emptyCart }
